var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"title-translation-path":"admin.dictionariesSettings","has-buttons":false,"inputs":_vm.inputs},scopedSlots:_vm._u([{key:"dictionaries.input",fn:function(){return [_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"8"}},[_c('DictionariesSettingsList')],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }